export const useFingerprint = () => {
    const { $fingerprintId } = useNuxtApp()
    return { $fingerprintId: $fingerprintId as string }
}
